import { useState, useEffect } from "react";
import * as React from "react";
import {
  Select,
  MenuItem,
  Typography,
  Stack,
  TableCell,
  TableRow,
  IconButton,
  Tooltip,
} from "@mui/material";
import { TrueffortTextField } from "../../MUIstyle/MUICustom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CancelIcon from "@mui/icons-material/Cancel";
import Limit from "../estimation/Limit";
import { TOOLS_EXTERNAL_NAME } from "../../util/Constants";

const sizeOptions = [
  { idSize: 1, size: "estimation_page.small_size" },
  { idSize: 2, size: "estimation_page.medium_size" },
  { idSize: 3, size: "estimation_page.large_size" },
  { idSize: 4, size: "estimation_page.very_large_size" },
];

const complexityOptions = [
  { idComplexity: 1, complexity: "estimation_page.low_complexity" },
  { idComplexity: 2, complexity: "estimation_page.medium_complexity" },
  { idComplexity: 3, complexity: "estimation_page.large_complexity" },
];

function APITaskTableRow({
  task,
  t,
  elementTypes,
  matches,
  onRowDataChange,
  onDeleteRow,
  estimated,
  idEstimationType,
  selectedAPI,
}: any) {
  //console.log(task);

  const [effortFocused, setEffortFocused] = useState(false);
  const [durationFocused, setDurationFocused] = useState(false);

  // Estado para almacenar y actualizar el esfuerzo, inicializado con rowData.estimatedTime o 1
  const [elementEffort, setElementEffort] = useState(task.estimatedTime);

  // Estado para almacenar y actualizar la duración, inicializada con rowData.estimatedDays o 1
  const [elementDuration, setElementDuration] = useState(task.estimatedDays);

  useEffect(() => {
    setElementEffort(task?.estimatedTime);
    setElementDuration(task?.estimatedDays);
  }, [task]);

  const handleEffortChange = (value: number) => {
    if (
      value < 0 ||
      (task.effortMax != 0 &&
        task.effortMin != 0 &&
        (value > task.effortMax || value < task.effortMin))
    ) {
      //setElementEffort(task.estimatedTime);
      return;
    }

    setElementEffort(value);
    onRowDataChange.onEffortChange(task.apiID, value, task.estimatedTime);
  };

  const handleDurationChange = (value: number) => {
    if (
      value < 0 ||
      (task.durationMax != 0 &&
        task.durationMax != 0 &&
        (value > task.durationMax || value < task.durationMax))
    ) {
      //setElementDuration(Math.round(task.estimatedDays));
      return;
    }

    setElementDuration(value);
    onRowDataChange.onDurationChange(task.apiID, value);
  };

  // Función para manejar el cambio del tipo de elemento seleccionado
  const handleChangeElementType = (idElementType: number) => {
    //setIdSelectedElementType(id);
    onRowDataChange.onElementTypeChange(task.apiID, idElementType); // Llama a la función onElementTypeChange recibida como prop
  };

  useEffect(() => {
    if (task.idElementType == "" && elementTypes.length == 1) {
      handleChangeElementType(elementTypes[0].idElementType);
    }
  });

  const handleChangeSize = (idSize: number) => {
    onRowDataChange.onSizeChange(task.apiID, idSize);
  };

  const handleChangeComplexity = (idComplexity: number) => {
    onRowDataChange.onComplexityChange(task.apiID, idComplexity);
  };

  // Define una función handleDeleteRow que establece isDeleted en true y llama a la función onDeleteRow
  const handleDeleteRow = () => {
    // Establece isDeleted en true
    //setIsDeleted(true);
    // Llama a la función onDeleteRow pasando la clave de la tarea o elemento que se va a eliminar
    onDeleteRow(task.id);
  };

  const handleEffortBlur = () => {
    if (elementEffort === "") {
      setElementEffort(task.estimatedTime);
    } else {
      handleEffortChange(Number(elementEffort));
    }

    setEffortFocused(false);
  };

  const handleDurationBlur = () => {
    if (elementDuration === "") {
      setElementDuration(Math.round(task.estimatedDays));
    } else {
      handleDurationChange(Math.round(Number(elementDuration)));
    }

    setDurationFocused(false);
  };

  const getCell = (children: any) => {
    return <TableCell style={{ padding: "5px" }}>{children}</TableCell>;
  };

  return (
    <>
      <TableRow style={{ backgroundColor: "white" }}>
        <TableCell
          sx={{
            width: "35%",
            maxWidth: 600,
            verticalAlign: "top",
          }}
        >
          <Typography
            fontWeight={600}
            sx={{
              whiteSpace: "normal",
              overflowWrap: "break-word",
              lineHeight: 1.3,
            }}
          >
            {task.name}
          </Typography>
        </TableCell>
        {getCell(
          <Select
            id="element-type-select"
            name="ElementType"
            size="small"
            sx={{ backgroundColor: "#F5F5F5", color: "#07074E" }}
            IconComponent={KeyboardArrowDownIcon}
            displayEmpty
            value={task.idElementType} //Valor del tipo de elemento seleccionado
            onChange={(e) => handleChangeElementType(e.target.value)} //Llama a la función para hacer el cambio del tipo de elemento seleccionado
            //disabled={isDeleted} //Este select se deshabilitará si la fila fue eliminada
          >
            <MenuItem value="" disabled>
              {t("Select")}
            </MenuItem>
            {/* Muestra la lista de los elementos de la plantilla seleccionada */}
            {elementTypes.map((elemType: any) => (
              <MenuItem
                key={elemType.idElementType}
                value={elemType.idElementType}
              >
                {/* Muestra el nombre del elemento*/}
                {elemType.name}
              </MenuItem>
            ))}
          </Select>,
        )}
        {getCell(
          <Stack direction="column" spacing={1}>
            {/*Seleccionar el tamaño */}
            <Select
              id="base-elements-size"
              size="small"
              sx={{ backgroundColor: "#F5F5F5", color: "#07074E" }}
              IconComponent={KeyboardArrowDownIcon}
              displayEmpty
              value={task.idSize}
              onChange={(event) => handleChangeSize(event.target.value)} //Cambia el tipo de valor seleccionado
              //disabled={isDeleted} //Este select se deshabilitará si la fila fue eliminada
            >
              <MenuItem value="" disabled>
                {t("Select")}
              </MenuItem>
              {/* Muestra la lista de los tamaños */}
              {sizeOptions.map((option) => (
                <MenuItem key={option.idSize} value={option.idSize}>
                  {/*Muestra el nombre del tamaño seleccionado */}
                  {t(option.size)}
                </MenuItem>
              ))}
            </Select>
          </Stack>,
        )}
        {getCell(
          <Stack direction="column" spacing={1}>
            {/*Seleccionar la complejidad */}
            <Select
              id="base-elements-complexity"
              size="small"
              sx={{ backgroundColor: "#F5F5F5", color: "#07074E" }}
              IconComponent={KeyboardArrowDownIcon}
              displayEmpty
              value={task.idComplexity} //Valor de la complejidad seleccionada
              onChange={(event) => handleChangeComplexity(event.target.value)} //Cambia el tipo de valor seleccionado
              //disabled={isDeleted} //Este select se deshabilitará si la fila fue eliminada
            >
              <MenuItem value="" disabled>
                {t("Select")}
              </MenuItem>
              {/*Mostrar la lista de las complejidades */}
              {complexityOptions.map((option) => (
                <MenuItem key={option.idComplexity} value={option.idComplexity}>
                  {/*Muestra el nombre de la complejidad */}
                  {t(option.complexity)}
                </MenuItem>
              ))}
            </Select>
          </Stack>,
        )}
        {getCell(
          <Stack
            direction="row"
            spacing={1}
            style={{
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {false && !["1", "4"].includes(idEstimationType) && (
              <Limit
                isMax={false}
                disabled={!estimated}
                total={Math.round(task.estimatedTime)}
                estimatedVal={task.effortMin}
                label={task.effortMin}
                handle={handleEffortChange}
              />
            )}
            <Stack
              direction="column"
              spacing={0}
              alignItems="center"
              justifyContent="center"
            >
              {!["1", "4"].includes(idEstimationType) && (
                <Typography variant="caption">
                  {t("estimation_page.avg")}
                </Typography>
              )}
              {/*Input para ingresar el esfuerzo */}
              <TrueffortTextField
                type="number"
                InputProps={{
                  inputProps: {
                    min: 0,
                    step: 0.1,
                    style: {
                      background: "#F5F5F5",
                      height: "7px",
                    },
                  },
                }}
                //value={initialEffort} //Valor del esfuerzo
                value={elementEffort}
                // onChange={(e: any) => setInitialEffort(e.target.value)} //Cambio del valor del esfuerzo
                onBlur={handleEffortBlur}
                onChange={(event: any) =>
                  handleEffortChange(Number(event.target.value))
                }
                onKeyDown={(event: any) => {
                  if (event.key === "Enter") {
                    handleEffortChange(Number(event.target.value));
                  }
                }}
                fullWidth
                sx={{
                  width: matches
                    ? "100%"
                    : ["1", "4"].includes(idEstimationType)
                      ? "120px"
                      : "80px",
                }}
                error={task.estimatedTime <= 0 || elementEffort <= 0}
                disabled={!estimated}
              />
              {(Math.round(task.estimatedTime) <= 0 || elementEffort <= 0) && (
                <span className="text-danger">
                  {t("estimation_page.cero_effort_error")}
                </span>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ textAlign: "center", minWidth: "50px" }}></div>
                  <div style={{ textAlign: "center", minWidth: "150px" }}>
                    {t("estimation_page.reference_values")}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ width: "25%", textAlign: "center" }}></div>
                  <div style={{ width: "25%", textAlign: "center" }}>
                    {"Min"}
                  </div>
                  <div style={{ width: "25%", textAlign: "center" }}>
                    {"Prom"}
                  </div>
                  <div style={{ width: "25%", textAlign: "center" }}>
                    {"Max"}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <img
                      src={
                        selectedAPI == TOOLS_EXTERNAL_NAME.jira
                          ? "./assets/images/atlassian_jira_logo.png"
                          : "./assets/images/azure_devops_logo.png"
                      }
                      style={{
                        margin: "0 0.5em",
                        display: "block",
                        width: "15px",
                        height: "15px",
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}> </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <Limit
                      title="none"
                      isMax={undefined}
                      disabled={false}
                      total={Math.round(task.estimatedTime)}
                      estimatedVal={task?.estimatedTimeTool}
                      label={task?.estimatedTimeTool}
                      handle={handleEffortChange}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}> </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <img
                      src="./assets/images/group.png"
                      style={{
                        margin: "0 0.5em",
                        display: "block",
                        width: "15px",
                        height: "15px",
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <Limit
                      title="none"
                      isMax={undefined}
                      disabled={false}
                      total={Math.round(task.estimatedTime)}
                      estimatedVal={task?.trEffortMinSug}
                      label={task?.trEffortMinSug}
                      handle={handleEffortChange}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <Limit
                      isMax={undefined}
                      title="none"
                      disabled={false}
                      total={Math.round(task.estimatedTime)}
                      estimatedVal={task?.trEffortSug}
                      label={task?.trEffortSug}
                      handle={handleEffortChange}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <Limit
                      title="none"
                      isMax={undefined}
                      disabled={false}
                      total={Math.round(task.estimatedTime)}
                      estimatedVal={task?.trEffortMaxSug}
                      label={task?.trEffortMaxSug}
                      handle={handleEffortChange}
                    />
                  </div>
                </div>
              </div>
            </Stack>
            {false && !["1", "4"].includes(idEstimationType) && (
              <Limit
                isMax={true}
                disabled={!estimated}
                total={Math.round(task.estimatedTime)}
                estimatedVal={task.effortMax}
                label={task.effortMax}
                handle={handleEffortChange}
              />
            )}
          </Stack>,
        )}
        {getCell(
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            {false && !["1", "4"].includes(idEstimationType) && (
              <Limit
                isMax={false}
                disabled={!estimated}
                total={Math.round(task.estimatedDays)}
                estimatedVal={task.durationMin}
                label={task.durationMin}
                handle={handleDurationChange}
              />
            )}

            <Stack
              direction="column"
              spacing={0}
              alignItems="center"
              justifyContent="center"
            >
              {!["1", "4"].includes(idEstimationType) && (
                <Typography variant="caption">
                  {t("estimation_page.avg")}
                </Typography>
              )}

              {/*Input para ingresar la duración */}
              <TrueffortTextField
                type="number"
                InputProps={{
                  inputProps: {
                    min: 1,
                    /*max: 99999.99,
                    step: 1,*/
                    style: {
                      background: "#F5F5F5",
                      height: "7px",
                    },
                  },
                }}
                value={durationFocused ? elementDuration : task.estimatedDays}
                onFocus={() => setDurationFocused(true)}
                onBlur={handleDurationBlur}
                onChange={(event: any) =>
                  durationFocused
                    ? setElementDuration(event.target.value)
                    : handleDurationChange(
                        Math.round(Number(event.target.value)),
                      )
                }
                onKeyDown={(event: any) => {
                  if (event.key === "Enter")
                    handleDurationChange(
                      Math.round(Number(event.target.value)),
                    );
                }}
                error={
                  Math.round(task.estimatedDays) <= 0 || elementDuration <= 0
                }
                fullWidth
                sx={{ width: matches ? "100%" : "80px" }}
                disabled={!estimated}
              />
              {(Math.round(task.estimatedDays) <= 0 ||
                elementDuration <= 0) && (
                <span className="text-danger">
                  {t("estimation_page.cero_duration_error")}
                </span>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ textAlign: "center", minWidth: "50px" }}></div>
                  <div style={{ textAlign: "center", minWidth: "150px" }}>
                    {t("estimation_page.reference_values")}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ width: "25%", textAlign: "center" }}></div>
                  <div style={{ width: "25%", textAlign: "center" }}>
                    {"Min"}
                  </div>
                  <div style={{ width: "25%", textAlign: "center" }}>
                    {"Prom"}
                  </div>
                  <div style={{ width: "25%", textAlign: "center" }}>
                    {"Max"}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <img
                      src={
                        selectedAPI == TOOLS_EXTERNAL_NAME.jira
                          ? "./assets/images/atlassian_jira_logo.png"
                          : "./assets/images/azure_devops_logo.png"
                      }
                      style={{
                        margin: "0 0.5em",
                        display: "block",
                        width: "15px",
                        height: "15px",
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}> </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <Limit
                      title="none"
                      isMax={undefined}
                      disabled={!estimated}
                      total={Math.round(task.estimatedDays)}
                      estimatedVal={task.estimatedDaysTool}
                      label={task.estimatedDaysTool}
                      handle={handleDurationChange}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}> </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "90%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <img
                      src="./assets/images/group.png"
                      style={{
                        margin: "0 0.5em",
                        display: "block",
                        width: "15px",
                        height: "15px",
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <Limit
                      title="none"
                      isMax={undefined}
                      disabled={false}
                      total={Math.round(task.estimatedDays)}
                      estimatedVal={task.trDurationMinSug}
                      label={task.trDurationMinSug}
                      handle={handleDurationChange}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <Limit
                      title="none"
                      isMax={undefined}
                      disabled={false}
                      total={Math.round(task.estimatedDays)}
                      estimatedVal={task.trDurationSug}
                      label={task.trDurationSug}
                      handle={handleDurationChange}
                    />
                  </div>
                  <div style={{ minWidth: "50px", textAlign: "center" }}>
                    <Limit
                      title="none"
                      isMax={undefined}
                      disabled={false}
                      total={Math.round(task.estimatedDays)}
                      estimatedVal={task.trDurationMaxSug}
                      label={task.trDurationMaxSug}
                      handle={handleDurationChange}
                    />
                  </div>
                </div>
              </div>
            </Stack>
            {false && !["1", "4"].includes(idEstimationType) && (
              <Limit
                isMax={true}
                disabled={!estimated}
                total={Math.round(task.estimatedDays)}
                estimatedVal={task.durationMax}
                label={task.durationMax}
                handle={handleDurationChange}
              />
            )}
          </Stack>,
        )}
        {getCell(
          <Typography variant="subtitle2" align="center">
            {/*{currentAPI === "Jira REST API" ? task.fields.status.name : task.fields["System.State"]}*/}
            {task.status}
          </Typography>,
        )}
        {getCell(
          <Tooltip title="Quitar">
            <IconButton color="error" onClick={handleDeleteRow}>
              <CancelIcon />
            </IconButton>
          </Tooltip>,
        )}
      </TableRow>
    </>
  );
}

export default React.memo(APITaskTableRow);
